import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'pfpayment';
export const route = 'pfpayment/[searchId]/[fareItineraryKey]/[segmentKeys]/[shoppingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "pfpayment" */
/* webpackPrefetch: true */
'../components/PaymentPage')));